import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import {
  getAssociateOperationProcessStep,
  deleteAssociateOperationProcessStepById,
} from "../../api/associate-operation-process-step";
import Confirm from "../../components/Confirm";

const AssociateOperationProcessStepTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [associateOperationProcessStep, setAssociateOperationProcessStep] = useState(null);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(operationId) {
    setSelectedOperationId(operationId);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteAssociateOperationProcessStepById(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getAssociateOperationProcessStep();

      setAssociateOperationProcessStep(res.sort((a, b) => a.operationId - b.operationId));
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("associate_process_step.operation_title")}</Typography>
      {associateOperationProcessStep ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/associate-operation-process-step/add`)}>
              <PostAddIcon />
              {t("associate_process_step.add_action")}
            </Button>
          }
          search={["name"]}
          header={[{ title: t("operations") }, { title: t("course_tree.process_step") }, { title: t("actions") }]}
          items={associateOperationProcessStep}
          renderChildren={(ps) => (
            <TableRow key={ps.operationId}>
              <TableCell>
                {ps.operationId} - {ps.operationName}
              </TableCell>
              <TableCell>
                {ps.data.map((o) => (
                  <li>
                    {o.processStepId} - {o.processStepName}
                  </li>
                ))}
              </TableCell>
              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/associate-operation-process-step/edit/${ps.operationId}`)}
                  title={t("associate_process_step.edit_operation_action")}
                />
                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(ps.operationId)}
                  title={t("associate_process_step.delete_operation_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("associate_process_step.delete_operation_action")} onConfirm={confirmDeleteModal}>
          <p>{t("associate_process_step.delete_operation_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default AssociateOperationProcessStepTable;
